import { render, staticRenderFns } from "./Add-User.vue?vue&type=template&id=5b277b54&scoped=true&"
import script from "./Add-User.vue?vue&type=script&lang=js&"
export * from "./Add-User.vue?vue&type=script&lang=js&"
import style0 from "./Add-User.vue?vue&type=style&index=0&id=5b277b54&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b277b54",
  null
  
)

export default component.exports